import { Checkbox, FormControl, FormControlLabel, Typography } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';

interface CheckboxFieldProps {
  label: string;
  disabled?: boolean;
  value: boolean;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  readOnly?: boolean;
}

export const CheckboxField = ({ label, disabled, value, onChange, error, readOnly }: CheckboxFieldProps) => {
  return (
    <>
      <FormControl fullWidth size="small" sx={{ pointerEvents: readOnly ? 'none' : 'auto' }}>
        <FormControlLabel
          disabled={disabled}
          control={<Checkbox disabled={disabled} value="on" checked={value} onChange={(e) => onChange(e.target.checked)} />}
          label={label}
        />
      </FormControl>
      {error && (
        <Typography variant="caption" color="error">
          {error!.message as string}
        </Typography>
      )}
    </>
  );
};
